package fr.labodoc.healthProfessional.webApp.layouts

import fr.labodoc.healthProfessional.webApp.App
import fr.labodoc.healthProfessional.webApp.Page
import fr.labodoc.healthProfessional.webApp.components.navigoLink
import fr.labodoc.healthProfessional.webApp.components.picture
import fr.labodoc.healthProfessional.webApp.data.model.HealthProfessionalUserModel
import fr.labodoc.require
import io.kvision.html.*
import kotlinx.browser.document
import org.w3c.dom.Node
import org.w3c.dom.events.MouseEvent

class LabodocHeader : Header() {
  init {
    id = "labodoc-header"
    require("./css/labodoc-header.css")

    val user = App.Companion.user.getState()

    div {
      id = "labodoc-header-content"

      div {
        id = "labodoc-header-logo"

        div(className = "page-width") {
          val url = when (user) {
            is HealthProfessionalUserModel -> Page.Dashboard().url
            null -> Page.Home().url
          }

          navigoLink(label = "", url = url) {
            picture(require("./img/Labodoc-logotype-horizontal-blanc.svg"), alt = "LaboDoc") {
              addSource("(max-width:700px)", require("./img/Labodoc-logotype-horizontal-couleur.svg"))
            }
          }
        }
      }

      div {
        id = "labodoc-header-nav"

        div(className = "page-width") {
          nav {
            val cssOpenClass = "open"

            if (user != null) {
              div(className = "profile") ProfileContainer@{

                button("Profil", "fa-solid fa-user") {
                  onClick {
                    if (this@ProfileContainer.hasCssClass(cssOpenClass))
                      this@ProfileContainer.removeCssClass(cssOpenClass)
                    else
                      this@ProfileContainer.addCssClass(cssOpenClass)
                  }

                  document.addEventListener("click", { event ->
                    if (event is MouseEvent) {
                      val target = event.target

                      if ((target !is Node || this.getElement()
                          ?.contains(target) == false) && this@ProfileContainer.hasCssClass(cssOpenClass)
                      )
                        this@ProfileContainer.removeCssClass(cssOpenClass)
                    }
                  })
                }

                div(className = "dropdown") {
                  p("${user.firstName} ${user.lastName}", className = "title")

                  navigoLink("Mes informations", Page.ProfileInformation())

                  if (user.canHaveMedicalInterests)
                    navigoLink("Mes centres d'intérêts", Page.ProfileMedicalInterests())

                  navigoLink("Mes préférences de notifications", Page.ProfileNotificationsSettings())

                  navigoLink("Nous contacter", Page.Contact())
                  navigoLink("Se déconnecter", Page.Logout())
                }
              }

              div(className = "medical-directory") MedicalDirectoryContainer@{
                button("Liens utiles", "fa-solid fa-address-book") {
                  onClick {
                    if (this@MedicalDirectoryContainer.hasCssClass(cssOpenClass))
                      this@MedicalDirectoryContainer.removeCssClass(cssOpenClass)
                    else
                      this@MedicalDirectoryContainer.addCssClass(cssOpenClass)
                  }

                  document.addEventListener("click", { event ->
                    if (event is MouseEvent) {
                      val target = event.target

                      if ((target !is Node || this.getElement()
                          ?.contains(target) == false) && this@MedicalDirectoryContainer.hasCssClass(cssOpenClass)
                      )
                        this@MedicalDirectoryContainer.removeCssClass(cssOpenClass)
                    }
                  })
                }

                div(className = "dropdown") {
                  navigoLink(
                    "Les Sociétés Savantes",
                    Page.LearnedSocietiesList(),
                  )

                  navigoLink(
                    "Les Laboratoires",
                    Page.LaboratoriesList(),
                  )

                  link("ANSM", "https://ansm.sante.fr/", target = "_blank")

                  link("HAS", "https://www.has-sante.fr/", target = "_blank")


                  link(
                    "Base de données publique des médicaments",
                    "https://base-donnees-publique.medicaments.gouv.fr",
                    target = "_blank"
                  )

                  link("Portail de pharmacovigilance", "https://signalement.social-sante.gouv.fr/", target = "_blank")
                }
              }
            }
          }
        }
      }
    }

    div {
      id = "labodoc-header-spacer"
    }
  }
}
